export default __webpack_public_path__ + "static/media/Q19_3_resized.787a7b21.jpg";